import { Skeleton, useTheme } from '@mui/material';
import { AssetUrls } from 'config/assets';
import './Points.css';

const PLACEHOLDER_SIZES = (isBig: boolean) =>
  isBig ? { width: 96, height: 32 } : { width: 65, height: 19 };

interface Props {
  type?: 'default' | 'big' | 'small';
  points?: number;
  isLoading?: boolean;
}

const formatter = new Intl.NumberFormat('en-US');

export const Points = ({ type = 'default', points = 0, isLoading }: Props) => {
  const theme = useTheme();
  const pointsToString = formatter.format(points);
  const isBig = type === 'big';
  
  // Determine expansion class based on character count
  const getExpandClass = () => {
    const charCount = pointsToString.length;
    if (charCount < 8) return '';
    if (charCount <= 10) return 'expand'; // Keep original for backward compatibility
    if (charCount <= 13) return 'expand-md';
    if (charCount <= 16) return 'expand-lg';
    return 'expand-xl';
  };
  
  const expandClass = getExpandClass();
  const coinIconSizes = isBig
    ? { width: 21.89, height: 21.89 }
    : { width: 16, height: 16 };

  if (isLoading) {
    return (
      <Skeleton
        variant="rounded"
        sx={{ backgroundColor: theme.colors.grey, borderRadius: 12 }}
        {...PLACEHOLDER_SIZES(isBig)}
      />
    );
  }

  return (
    <div className={`profile-points ${type} ${expandClass}`}>
      <div className={`profile-points-content ${isBig ? 'big' : ''}`}>
        <img
          src={`${AssetUrls.base}/assets/icons/profile/coin.svg`}
          {...coinIconSizes}
          alt="coin-image"
        />
        <div className={`profile-points-text ${isBig ? 'big' : ''}`}>
          {pointsToString}
        </div>
      </div>
    </div>
  );
};
